import React, { forwardRef } from 'react';
import clsx from 'clsx';
import './modal.scss';
import PropTypes from 'prop-types';
import AnimateHeight from '../animate-height';
import withBackdrop from '../../enhancers/hoc/withBackdrop';
import ModalContent from './views/modal-content/modal-content';
import {
  BUFFER_HEIGHT,
  ModalTypes,
  TransitionDelay,
  TransitionDuration,
} from './constants';

/* eslint-disable react/jsx-props-no-spreading */
const Modal = forwardRef(({
  type, renderIcon, className, children, ...props
}, ref) => {
  const getView = () => {
    switch (type) {
      case ModalTypes.CUSTOM:
        return children;

      case ModalTypes.WITH_HEIGHT_TRANSITIONS:
        return (
          <AnimateHeight
            delay={TransitionDelay}
            bufferHeight={BUFFER_HEIGHT}
            duration={TransitionDuration}
          >
            <ModalContent renderIcon={renderIcon} type={type} {...props}>
              {children}
            </ModalContent>
          </AnimateHeight>
        );

      case ModalTypes.DEFAULT:
        return (
          <ModalContent renderIcon={renderIcon} type={type} {...props}>
            {children}
          </ModalContent>
        );

      default:
        return null;
    }
  };

  return (
    <div ref={ref} className={clsx('modal-cont', className)}>
      {getView()}
    </div>
  );
});

Modal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  type: PropTypes.oneOf(Object.values(ModalTypes)),
  renderIcon: PropTypes.func,
};

Modal.defaultProps = {
  className: '',
  renderIcon: null,
  children: null,
  type: ModalTypes.DEFAULT,
};

export default withBackdrop(Modal);
